import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, VALID_LANGS, getLandingCopy } from "./translations";

const LangContext = createContext({
  lang: "it",
  setLang: () => {},
  t: translations.it,
  landing: getLandingCopy("it"),
});

const STORAGE_KEY = "app_language";

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
    return saved && VALID_LANGS.includes(saved) ? saved : "it";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    if (!VALID_LANGS.includes(l)) return;
    setLangState(l);
    try {
      localStorage.setItem(STORAGE_KEY, l);
    } catch (_) {}
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t: translations[lang], landing: getLandingCopy(lang) }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
